import { CommonModel } from '@telialt/models/src/CommonModel';

import { usePathname } from './pathname';

export enum TeliaSegment {
    B2b = 'b2b',
    B2c = 'b2c',
    Fix = 'fix',
    English = 'english',
    Russian = 'russian',
}

export enum SegmentSlug {
    B2b = 'verslui',
    B2c = 'privatiems',
}

export const SEGMENT_MATCHES = {
    [TeliaSegment.B2c]: [/^\/extra(?:\/.*)?/, /^\/mano\/privatiems(?:\/.*)?/, /^\/privatiems(?:\/.*)?/],
    [TeliaSegment.B2b]: [/^\/mano\/verslui(?:\/.*)?/, /^\/verslui(?:\/.*)?/],
    [TeliaSegment.Fix]: [/^\/mano\/paskyra(?:\/.*)?/],
    [TeliaSegment.English]: [/^\/eng(?:\/.*)?/],
    [TeliaSegment.Russian]: [/^\/rus(?:\/.*)?/],
};

export const getSegment = (path: string): TeliaSegment => {
    const segments = Object.keys(SEGMENT_MATCHES) as TeliaSegment[];
    const matchedSegment = segments.find((segment) => {
        return SEGMENT_MATCHES[segment].some((regex) => regex.test(path));
    });

    if (matchedSegment) {
        return matchedSegment;
    }

    if (typeof window !== 'undefined' && window.ACC?.segment) {
        return window.ACC.segment.toLowerCase();
    }

    return TeliaSegment.B2c;
};

export const useSegment = (): TeliaSegment => {
    const pathname = usePathname();

    // NOTE: this is for full backward compatibility with getHybrisSegment
    const windowSegment =
        typeof window !== 'undefined'
            ? window.ACC?.segment?.toLowerCase() || window.leadSegment?.toLowerCase()
            : undefined;

    if (windowSegment) {
        return windowSegment;
    }

    return pathname ? getSegment(pathname) : TeliaSegment.B2c;
};

export const getSiteName = (segment: TeliaSegment) => {
    return segment === TeliaSegment.B2b ? 'teliaB2bWebsite' : 'teliaWebsite';
};

export const getSegmentSlug = (segment: TeliaSegment) => {
    return segment === TeliaSegment.B2b ? SegmentSlug.B2b : SegmentSlug.B2c;
};

export const getHybrisSegmentFromTeliaSegment = (pathSegment: TeliaSegment): CommonModel.Segment => {
    return pathSegment === TeliaSegment.Fix ? TeliaSegment.B2b : pathSegment;
};

export const useHybrisSegment = () => {
    const segment = useSegment();

    return getHybrisSegmentFromTeliaSegment(segment);
};

export const useSiteName = () => {
    const segment = useSegment();

    return getSiteName(segment);
};

export const useSegmentSlug = () => {
    const segment = useSegment();

    return getSegmentSlug(segment);
};
